<template>
<v-container class="container general-tab" grid-list-md>
	<v-layout row>
		<v-flex sm6>
			<v-card>
				<h3 class="caption-block">
					{{ $t('workers.general') }}
				</h3>
				<v-card-title primary-title>
					<v-flex sm4>
						<v-text-field
							:label="$t('workers.firstname')"
							v-model="worker.firstname"
						/>
					</v-flex>
					<v-flex sm4>
						<v-text-field
							:label="$t('workers.lastname')"
							v-model="worker.lastname"
						/>
					</v-flex>
					<v-flex sm4>
						<v-select
							:items="tituls1"
							:label="$t('workers.titul')"
							v-model="worker.titul"
						/>
					</v-flex>
					<v-flex sm4>
						<v-select
							:items="genders"
							:label="$t('workers.gender')"
							v-model="worker.gender"
							item-text="name"
							item-value="key"
						/>
					</v-flex>
					<v-flex sm4>
						<v-select
							:items="citizenship"
							:label="$t('workers.citizenship')"
							v-model="worker.citizenship"
							item-value="code"
							item-text="name"
						/>
					</v-flex>
					<v-flex sm4>
						<v-text-field
							:label="$t('workers.rodni_chisla')"
							v-model="worker.rodni_chisla"
						/>
					</v-flex>
					<v-flex sm6>
						<DatePicker
							v-model="worker.birth_date"
							:label="$t('workers.birth_date')"
						/>
					</v-flex>
					<v-flex sm6>
						<v-text-field
							:label="$t('workers.birth_place')"
							v-model="worker.birth_place"
						/>
					</v-flex>
					<v-flex sm6>
						<v-select
							:items="agencies"
							:label="$t('agencies.agency')"
							v-model="worker.agency_id"
							item-value="id"
							item-text="name"
						/>
					</v-flex>
					<v-flex sm6>
						<v-select
							:items="civilStatuses"
							:label="$t('workers.civil_status')"
							v-model="worker.civil_status"
							item-text="name"
							item-value="key"
						/>
					</v-flex>
				</v-card-title>
			</v-card>
		</v-flex>
		<v-flex sm6>
			<v-card>
				<h3 class="caption-block">
					{{ $t('workers.insurance') }}
				</h3>
				<v-card-title primary-title>
					<v-flex sm12>
						<v-text-field
							:label="$t('workers.insurance_number')"
							v-model="worker.insurance_number"
						/>
					</v-flex>
					<v-flex sm12>
						<v-select
							:items="insuranceCompanies"
							:label="$t('common.insurance_company')"
							v-model="worker.insurance_company"
							item-value="key"
							item-text="value"
						>
							<template slot="selection" slot-scope="data">
								{{ data.item.key }} - {{ data.item.value }}
							</template>
							<template slot="item" slot-scope="data">
								{{ data.item.key }} - {{ data.item.value }}
							</template>
						</v-select>
					</v-flex>
					<v-flex sm12>
						<DatePicker
							v-model="worker.insurance_start_at"
							:label="$t('workers.insurance_start_at')"
						/>
					</v-flex>
					<v-flex sm12>
						<DatePicker
							v-model="worker.insurance_end_at"
							:label="$t('workers.insurance_end_at')"
						/>
					</v-flex>
				</v-card-title>
			</v-card>
		</v-flex>
	</v-layout>
	<v-layout row>
		<v-flex sm6>
			<v-card class="contact-card">
				<h3 class="caption-block">
					{{ $t('workers.contacts') }}
				</h3>
				<v-card-title primary-title>
					<v-flex sm12>
						<Contacts
							@add="addContact"
							@delete="deleteContact"
							:contact-types="$t('contacts')"
							:contacts="worker.contacts"
						/>
					</v-flex>
				</v-card-title>
			</v-card>
		</v-flex>
		<v-flex sm6>
			<v-card>
				<h3 class="caption-block">
					{{ $t('workers.education') }}
				</h3>
				<v-card-title primary-title>
					<v-flex sm6>
						<v-select
							:label="$t('workers.edu_type')"
							v-model="worker.edu_type"
							:items="educationTypes"
							item-value="key"
							item-text="value"
							return-object
						>
							<template slot="selection" slot-scope="data">
								{{ data.item.key }} - {{ data.item.value }}
							</template>
							<template slot="item" slot-scope="data">
								{{ data.item.key }} - {{ data.item.value }}
							</template>
						</v-select>
					</v-flex>
					<v-flex sm6>
						<v-text-field
							:label="$t('workers.edu_institution_name')"
							v-model="worker.edu_institution_name"
						/>
					</v-flex>
					<v-flex sm6>
						<DatePicker
							v-model="worker.edu_start"
							:label="$t('workers.edu_start')"
						/>
					</v-flex>
					<v-flex sm6>
						<DatePicker
							v-model="worker.edu_end"
							:label="$t('workers.edu_end')"
						/>
					</v-flex>
				</v-card-title>
			</v-card>
		</v-flex>
	</v-layout>
	<v-layout row>
		<v-flex sm12>
			<v-card>
				<h3 class="caption-block">
					{{ $t('workers.address') }}
				</h3>
				<v-card-title primary-title>
					<AddressGroup
						:onlyMultiple="true"
						:listAddress="worker.worker_home_address"
						@createMultiple="addAddress"
						@update="changeAddress"
						@delete="deleteWithNotify"
					/>
				</v-card-title>
			</v-card>
		</v-flex>
	</v-layout>
	<v-layout row justify-center>
		<v-tooltip top>
			<v-btn color="green lighten-1" class="white--text" slot="activator" @click="onSave">
				<v-icon>save</v-icon>
				<span style="padding-left: 5px">{{$t('common.save')}}</span>
			</v-btn>
			<span>
				{{$t('workers.save_general')}}
			</span>
		</v-tooltip>
	</v-layout>
</v-container>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import DatePicker from '../../../../components/DatePicker'
import Contacts from '../../../../components/Contacts'
import AddressGroup from '../../../../components/address-group/AddressGroup'
import { notify } from '../../../../utils/notifications'

export default {
	data: vm => ({
		civilStatuses: [
			{ key: 'merried', name: vm.$t('workers.merried') },
			{ key: 'not_merried', name: vm.$t('workers.not_merried') },
		],
		genders: [
			{ key: 'male', name: vm.$t('common.gender_male') },
			{ key: 'female', name: vm.$t('common.gender_female') },
		]
	}),
	computed: {
		...mapGetters({
			citizenship: 'settings/getCitizenship',
			educationTypes: 'settings/educationTypesKeyValue',
			tituls1: 'settings/tituls1',
			insuranceCompanies: 'settings/insuranceCompanies'
		}),
		...mapState({
			worker: ({ workers }) => workers.workerDetail
		}),
		agencies() {
			return [
				{
					id: null,
					name: this.$t('agencies.notAgency')
				},
				...this.$store.state.agencies.agencies,
			]
		},
		worker() {
			return this.$store.state.workers.workerDetail
		}
	},
	components: {
		DatePicker,
		Contacts,
		AddressGroup
	},
	methods: {
		...mapActions({
			save: 'workers/updateWorker',
			createAddress: 'workers/createAddress',
			updateAddress: 'workers/updateAddress',
			deleteAddress: 'workers/deleteAddress'
		}),
		...mapMutations({
			addContact: 'workers/addContact',
			deleteContact: 'workers/deleteContact'
		}),
		onSave() {
			this.save().then(() => {
				this.$notify({
					...notify,
					text: this.$t('notifications.saved', {
						type: this.$t('workers.general')
					})
				})
			})
		},
		addAddress(data) {
			this.createAddress({
				...data,
				addressable_type: 'worker_home_address'
			}).then(() => {
				this.$notify({
					...notify,
					text: this.$t('notifications.created', {
						type: this.$t('address.address')
					})
				})
			})
		},
		changeAddress(data) {
			this.updateAddress(data).then(() => {
				this.$notify({
					...notify,
					text: this.$t('notifications.updated', {
						type: this.$t('address.address')
					})
				})
			})
		},
		deleteWithNotify(id) {
			this.deleteAddress(id).then(() => {
				this.$notify({
					...notify,
					text: this.$t('notifications.deleted', {
						type: this.$t('address.address')
					})
				})
			})
		}
	}
}
</script>

<style scoped>
.container {
	padding-top: 0 !important;
}
.center {
	text-align: center;
}
.general-tab {
	background-color: whitesmoke;
	padding: 5px 0px 24px 0px !important;
}
.general-tab .caption-block {
	font-size: 18px;
	text-align: center;
	padding-top: 10px;
}
.contact-card {
	height: 100% !important;
}
</style>
